var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"border":"none","margin-top":"16px"},attrs:{"src":"https://prozesskostenrechner-dmb.dahag-web.de/","width":"100%","height":"1930"}})}
var staticRenderFns = []

export { render, staticRenderFns }